<template>
  <div @click="$emit('cardClick')" :class="{ 'bg-tertiary': isNew }">
    <div v-if="isNew" class="card-add">
      <b-button id="addNew" class="add-button bg-yellow01">
        <i class="material-icons add-icon"> add_circle </i>
      </b-button>
      <label for="addNew" class="add-label">{{ resources.newLabel }}</label>
    </div>
    <div v-if="!isNew" class="card-default">
      <div
        class="image-slot"
        :style="{ 'background-image': `url(${actionPlan.thumbnail})` }"
      ></div>
      <div class="action-card-content">
        <h1 :title="actionPlan.title">
          {{ actionPlan.title | truncateText(45) }}
        </h1>
        <p class="description" :title="actionPlan.description">
          {{ actionPlan.description | truncateText(100) }}
        </p>
        <hr />
        <span class="badge badge-light03" :title="actionPlan.metric.label">{{
          actionPlan.metric.label
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    actionPlan: {
      type: Object,
    },
    isNew: {
      type: Boolean,
    },
  },
  computed: {
    resources() {
      return this.$store.getters.resources.component.actionPlan.card
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/custom/colors';
$addMarginTop: 20px;

.card-add {
  display: flex;
  flex-direction: column;
  padding: 50% 0;

  .add-button {
    align-self: center;
    border: none;
    border-radius: 50px !important;
    height: 70px !important;
    padding-top: 10px;
    width: 70px !important;

    &:focus {
      box-shadow: none !important;
    }

    .add-icon {
      border-radius: 30px;
      color: map-get($theme-colors, 'primary');
      cursor: pointer;
      font-size: 35px;
      text-align: center;
      padding: 3px 0 0;
    }
  }

  .add-label {
    align-self: center;
    cursor: pointer;
    font-weight: 500;
    margin-top: $addMarginTop;
  }
}

.action-card-content {
  padding: 10px;
  height: 200px;

  h1 {
    font-size: 16px;
    height: 38px;
  }

  p {
    font-size: 13px;
    margin: 0;
    &.description {
      position: relative;
      height: 90px;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 1rem; /* space for ellipsis */
    }
  }

  hr {
    margin: 5px 0 10px;
  }

  .badge {
    color: map-get($theme-colors, 'primary');
    padding: 4px;
    font-weight: 300;
    margin: 2px;
  }
}

.image-slot {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  height: 130px;
  border-radius: 8px 8px 0 0;
}
</style>
